import { ComponentProps } from 'preact';
import { ReactNode } from 'preact/compat';

import { cn } from '@/lib/utils';
import { HabitatListItem } from '@/queries/habitats/types';

import { HabitatLinkProps } from '../HabitatLink';
import HabitatGridItem from './HabitatGridItem';

interface HabitatsGridProps extends ComponentProps<'div'> {
  habitats: HabitatListItem[];
  renderLink?: (props: HabitatLinkProps) => ReactNode;
}

const HabitatsGrid = ({ habitats, className, renderLink, ...props }: HabitatsGridProps) => {
  return (
    <div
      className={cn('grid grid-cols-2 gap-2 md:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] md:gap-4', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {habitats.map((habitat) => (
        <HabitatGridItem key={habitat._id} habitat={habitat} renderLink={renderLink} />
      ))}
    </div>
  );
};

export default HabitatsGrid;
